var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafariPinnedTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "700pt",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 700 700",
    width: "700pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.1 0 0 -.1 0 700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2625 6125v-875h875 875v873 872l-875 3-875 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 1750v-1750h3500 3500v1750 1750h-875-875v-875-875h-1750-1750v875 875h-875-875z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafariPinnedTab);
export default __webpack_public_path__ + "static/media/safari-pinned-tab.72bc0a8dfc658ce28eb4cba6885eadf1.svg";
export { ForwardRef as ReactComponent };